import { render, staticRenderFns } from "./NewsCon.vue?vue&type=template&id=c0d747f8&scoped=true&"
import script from "./NewsCon.vue?vue&type=script&lang=js&"
export * from "./NewsCon.vue?vue&type=script&lang=js&"
import style0 from "./NewsCon.vue?vue&type=style&index=0&id=c0d747f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0d747f8",
  null
  
)

export default component.exports